import { render, staticRenderFns } from "./ScopoRapporto.vue?vue&type=template&id=55ba3916&scoped=true&"
import script from "./ScopoRapporto.vue?vue&type=script&lang=js&"
export * from "./ScopoRapporto.vue?vue&type=script&lang=js&"
import style0 from "./ScopoRapporto.vue?vue&type=style&index=0&id=55ba3916&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55ba3916",
  null
  
)

export default component.exports